//Show Newsletter Popup
setTimeout(function(){

  var x = localStorage.getItem("mytime");
console.log(x);
  if( x != 1 ){
  $('#newsletter').addClass('showpopup');
  localStorage.setItem("mytime", '1');
}
},1500);

//Close Newsletter Popup
$('.popup__close').click(function () {
  $('#newsletter').removeClass('showpopup');
})

$('.thumbnail-list-slider').slick({
slidesToShow: 5,
slidesToScroll: 1,
arrows: false,
dots: true,
vertical: true,
verticalSwiping: true
    
});
